export default __webpack_public_path__ + "assets/images/e58075dfa13f96808361914ea1a31363.png";